import React from "react";

export default function FaqQuestions({ children }) {
  return <div className='faq-inner'>{children}</div>;
}
